import { render, staticRenderFns } from "./FooterLogoContainer.vue?vue&type=template&id=5721c276&scoped=true&"
import script from "./FooterLogoContainer.vue?vue&type=script&lang=js&"
export * from "./FooterLogoContainer.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogoContainer.vue?vue&type=style&index=0&id=5721c276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721c276",
  null
  
)

export default component.exports